export type ReatrementRecordType = {
  case_id: number;
  submitted: string;
  patient: string;
  physician: string;
  retreatment_id: number;
  patient_phone: number;
};
export type EOBsType = {
  id: number;
  insurance_name: string;
  insurance_type: string;
  insurance_mac: string;
  insurance_state: string;
  insurance_group:string
  speciality:string;
  cpt_codes: string;
  service_date: string;
  redacted_file: boolean;
};
export type EOBsAPIResponse = {
  data: EOBsType[];
  status: 200;
  total_pages: 1;
};

export type DeleteRetreatmentAPIRes = {
  message: string;
};
export type QueryParamsState = {
  // date_from: string;
  // date_to: string;
  insurance_name: string;
  pagination: boolean;
  page: number;
  sort_by: string;
  direction: "asc" | "desc";
  insurance_state: string;
  insurance_type: string;
  insurance_group: string;
  cpt_codes: string;
  insurance_mac: string;
  doctor_taxonomy: string;
};

export enum QueryStateActions {
  // CHANGE_FROM_DATE = "changeFromDate",
  // CHANGE_TO_DATE = "changeToDate",
  CHANGE_INSURANCE_NAME = "changeInsuranceName",
  CLEAR_STATE = "clearState",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
  CHANGE_PAGE = "changePage",
  CHANGE_SORT_PARAMS = "changeSortParams",
  CHANGE_INSURANCE_STATE = "changeInsuranceState",
  CHANGE_INSURANCE_TYPE = "changeInsuranceType",
  CHANGE_INSURANCE_GROUP = "changeInsuranceGroup",
  CHANGE_CPT_CODES = "changeCPTCodes",
  CHANGE_INSURANCE_MAC = "changeInsuranceMAC",
  CHANGE_DOCTOR_TAXONOMY = "changeDoctorTaxonomy",
}

export type QueryStateActionType =
  // | {
  //     type: QueryStateActions.CHANGE_FROM_DATE;
  //     payload: string;
  //   }
  // | {
  //     type: QueryStateActions.CHANGE_TO_DATE;
  //     payload: string;
  //   }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_NAME;
      payload: string;
    }
  | {
      type: QueryStateActions.CLEAR_STATE;
    }
  | {
      type: QueryStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    }
  | {
      type: QueryStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: QueryStateActions.CHANGE_SORT_PARAMS;
      payload: {
        sort_by: string;
        direction: "asc" | "desc";
      };
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_GROUP;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_STATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_TYPE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_CPT_CODES;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_MAC;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_DOCTOR_TAXONOMY;
      payload: string;
    };
